// fetchWithAuth.js
import axios from 'axios';
import deleteSession from './deleteSession';

const instance = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
});

instance.interceptors.request.use(config => {
  const session_id = localStorage.getItem('session_id');
  const username = localStorage.getItem('username');
  if (session_id && username) {
    config.headers['X-Session-ID'] = session_id;
    config.headers['X-Username'] = username;
  }
  return config;
});

let showAlertFn = null;

export function registerShowAlert(fn) {
  showAlertFn = fn;
}

// axios instance com interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401)) {
      if (showAlertFn) {
        showAlertFn('Sessão expirada. Faça login novamente.', 'error');
      }
      localStorage.removeItem('session_id');
      localStorage.removeItem('username');
      setTimeout(() => {
        // window.location.href = '/';
      }, 3000);  // esperar o alerta fechar antes de redirecionar
    }
    return Promise.reject(error);
  }
);

export default instance;
